import { Heading, HStack, IconButton, NaChevronDown, NaChevronUp, Stack } from '@metservicedev/met-ui';
import React from 'react';

import { createStyles } from '../tss';

const useStyles = createStyles(({ theme }) => ({
  root: {
    overflow: 'hidden',
    transition: 'height 300ms ease',
  },
  container: {
    gap: theme.spacing(3),
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
  },
}));

interface Props {
  children: React.ReactNode;
  className?: string;
  classes?: Partial<ReturnType<typeof useStyles>['classes']>;
  label: string;
}

export const FormSection: React.FC<Props> = ({
  children,
  classes: classesOverrides,
  className,
  label,
}) => {
  const { classes, cx } = useStyles({ classesOverrides });
  const [open, setOpen] = React.useState(true);
  return (
    <Stack gap={0}>
      <HStack>
        <IconButton
          data-testid={`toggle-section-${label}`}
          size="sm"
          icon={!open ? NaChevronUp : NaChevronDown}
          variant="tertiary"
          onClick={() => setOpen(!open)}
          type="button"
        />
        <Heading size="sm">{label}</Heading>
      </HStack>
      <div
        className={cx(classes.root, className)}
        data-testid="section-content-collapser"
        data-collapsed={!open}
        style={{ height: open ? undefined : 0 }}
      >
        <div className={classes.container}>
          {children}
        </div>
      </div>
    </Stack>
  );
};
